import { ImpactGauge } from "components/impact-gauge";
import { FuelRateGauge } from "components/fuel-rate-gauge";
import { PeakImpactStat } from "../stats/peak-impact";
import { RedImpactsStat } from "../stats/red-impacts";
import { CombinedGauge } from "components/combined-gauge";

export const CombinedGauges = () => {
  return (
    <div className="flex w-full h-full pb-6">
      <div className="h-full w-[25%] flex flex-col items-center justify-center">
        <div className="w-full h-[18%] shrink-0"></div>
        <div className="flex-1 w-full overflow-hidden">
          <ImpactGauge />
        </div>
        <div className="w-full h-[18%] shrink-0">
          <PeakImpactStat />
        </div>
      </div>
      <div className="h-full w-[50%] flex items-center justify-center">
        <CombinedGauge />
      </div>
      <div className="h-full w-[25%] flex flex-col items-center justify-center">
        <div className="w-full h-[18%] shrink-0 "></div>
        <div className="flex-1 w-full overflow-hidden">
          <FuelRateGauge />
        </div>
        <div className="w-full h-[18%] shrink-0 ">
          <RedImpactsStat />
        </div>
      </div>
    </div>
  );
};
